import styled, { css } from 'styled-components/macro'
import { Button } from 'components/ui'
import { darken, transparentize } from 'polished'

export const Wrap = styled.div`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
`

export const LoadingWrap = styled.div<{ position: string }>`
  display: flex;
  justify-content: ${(props) => props.position};
`

export const TokenWrap = styled.div`
  width: 100%;
  display: flex;
  gap: 0.4rem;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const Label = styled.label`
  margin: 0;
  width: fit-content;
  display: inline-block;
  font-weight: ${(props) => props.theme.font.weight.regular};
  font-size: 1.4rem;
  line-height: 1.4;
  color: ${(props) => transparentize(0.3, props.theme.color.text)};
`

export const TokenSelectWrap = styled(Button)`
  margin: 0;
  padding: 1.2rem 1rem;
  width: auto;
  gap: 0.8rem;
  flex: 0 0 100%;
  border-radius: 0.8rem;
  border-color: ${(props) => transparentize(0.5, props.theme.color.black)};
  text-transform: uppercase;
`

export const ChevronWrap = styled.span<{ isToggled?: boolean }>`
  opacity: ${(props) => props.theme.opacity.opacity05};
  transition: transform 0.3s ease-out;
  ${(props) =>
    props.isToggled &&
    css`
      transform: rotate(-180deg);
    `}
`

export const TokenList = styled.ul`
  list-style: none;
  left: -1.6rem;
  top: calc(100% + 0.4rem);
  position: absolute;
  margin: 0;
  padding: 0;
  width: max-content;
  max-width: 51rem;
  flex: 0 0 auto;
  background-color: ${(props) => props.theme.color.elementBgSecond};
  border: 0.1rem solid ${(props) => props.theme.color.default};
  border-radius: 1.2rem;
  z-index: ${(props) => props.theme.zIndex.navigation};
  overflow: hidden;
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
    width: 51rem;
  `};
`

export const TokenListItem = styled.li`
  margin: 0;
  padding: 0;
`

export const ItemBtn = styled.button`
  margin: 0;
  padding: 1rem 1.6rem;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.4rem;
  line-height: 1.44;
  color: ${(props) => props.theme.color.white};
  background-color: ${(props) => props.theme.color.elementBgSecond};
  border: none;
  border-bottom: 0.1rem solid ${(props) => transparentize(0.7, props.theme.color.white)};
  border-radius: 0;
  transition: color 0.2s ease-out, background-color 0.2s ease-out;
  cursor: pointer;
  outline: none;
  &:last-child {
    border-bottom: none;
  }
  &:hover:not([disabled]),
  &:focus:not([disabled]) {
    background-color: ${(props) => props.theme.color.default};
  }
  &:active:not([disabled]) {
    background-color: ${(props) => darken(0.1, props.theme.color.default)};
  }
`

export const TokenItemWrap = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  display: grid;
  grid-template-columns: 3.2rem auto;
  gap: 1.2rem;
  justify-content: flex-start;
  align-items: center;
`

export const TokenName = styled.span`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.6rem;
  line-height: 1.4;
`

export const Balance = styled.div`
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  gap: 0.4rem;
  justify-content: flex-end;
  align-items: center;
`

export const BalanceValue = styled.span`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 1.6rem;
  line-height: 1.4;
`

export const TokenSymbol = styled.span`
  margin: 0;
  font-weight: ${(props) => props.theme.font.weight.medium};
  font-size: 1.6rem;
  line-height: 1.4;
  text-transform: uppercase;
`
